// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3DGpv","name":"Header_name__1I9fL","birthday":"Header_birthday__1iFNk","skeleton":"Header_skeleton__3voR7"};